import { render, staticRenderFns } from "./AdminGuides.vue?vue&type=template&id=17070a6f&"
import script from "./AdminGuides.vue?vue&type=script&lang=js&"
export * from "./AdminGuides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports